import { render, staticRenderFns } from "./OnRatiosTableHeaders2.vue?vue&type=template&id=0b766c3d&"
import script from "./OnRatiosTableHeaders2.vue?vue&type=script&lang=js&"
export * from "./OnRatiosTableHeaders2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports